// extracted by mini-css-extract-plugin
export var root = "HighlightBlock-module--root--KP8jL";